export default __webpack_public_path__ + "static/media/ba.9c1d3ba2.svg";